// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.file-name,\n.el-table th.file-name {\n  width: 25em;\n}", ""]);
// Exports
module.exports = exports;
